module.exports = __webpack_public_path__ + "static/receitas-topo-d1c3d4011ec1dc8b96c0ab3dc4697925.svg";